// start:ng42.barrel
export * from './hex-colour.utils';
// end:ng42.barrel

